import { css } from '@emotion/react'

import type { StepperVariant } from '../stepper'

export const container = css`
  position: relative;
  grid-area: content;
`

export const alignment: Record<StepperVariant, ReturnType<typeof css>> = {
  vertical: css`
    align-self: start;
    justify-self: start;
  `,
  horizontal: css`
    align-self: start;
    justify-self: center;
  `,
}
